/**
 * Día de las Madres cards — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_may_june`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const diaDeLasMadresCardsPack: ToilePack = {
    slug: 'dia-de-las-madres-cards',
    category: 'season',
    name: 'Día de las Madres cards',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'felicidades', label: 'Feliz Día', subject: 'a vertical card lettered "Feliz Día de las Madres" above a spray of red roses and marigolds, an empty panel below for a handwritten note'},
        {key: 'tequiero', label: 'Te quiero, mamá', subject: 'a card with a large heart framed in papel picado flags and the words "Te quiero, mamá" set in its center'},
        {key: 'mejor', label: 'La mejor mamá', subject: 'a card with a ribbon banner reading "La mejor mamá del mundo", a small potted geranium beneath and a ruled message area at the foot'},
    ],
    styles: [
        {key: 'watercolor', label: 'Watercolor', style: 'soft watercolor illustration, loose edges, hand-lettered text', palette: 'rose red, marigold orange and leaf green washes on white paper', framing: 'Centered on the page with a wide white margin'},
        {key: 'papelpicado', label: 'Papel picado', style: 'cut-tissue papel picado look, bright flags with fine cut-out patterns, hand-lettered text', palette: 'hot pink, turquoise, marigold and lime on white', framing: 'Flags strung across the top of the card with a wide margin'},
        {key: 'flat', label: 'Flat color', style: 'flat vector illustration, bold clean shapes, smooth gradient-free fills, crisp lettering', palette: 'red, orange, teal and cream, a limited palette', framing: 'Full page on a solid cream ground with an even margin'},
    ],
    directions: ['Mexican style', 'Marigolds', 'Blue palette'],
    directionHint: 'try: Mexican style',
    seo: {
        title: 'Día de las Madres Cards: Feliz Día, Te quiero, mamá',
        metaDescription: 'Printable Día de las Madres cards in Spanish, with the greeting spelled exactly, in three styles and room for a message.',
        h1: 'Día de las Madres cards: Feliz Día, Te quiero, La mejor mamá',
        tagline: 'Nine printable cards in Spanish, each with the greeting spelled exactly and an empty panel for a message.',
        intro: 'Printable Spanish cards for Día de las Madres, kept on 10 May in Mexico and on other dates across Latin America and Spain. Each card carries a greeting such as Feliz Día de las Madres, Te quiero, mamá or La mejor mamá del mundo, with roses, marigolds or a heart. The message panel stays blank for the writer. Watercolor, papel picado and flat color styles. Type a different greeting, and the same card layout carries it.',
        useCases: [
            'a card for a mother or grandmother on Día de las Madres',
            'a card for a school celebration',
            'a card to send to family abroad',
            'a card a child colors and signs',
        ],
        faq: [
            {q: 'Is the greeting spelled correctly?', a: 'Yes. The greeting and its accents are lettered exactly as written on each card.'},
            {q: 'What is the papel picado style?', a: 'Bright cut-tissue flags with fine patterns are strung across the top of the card, in hot pink, turquoise, marigold and lime.'},
            {q: 'Can I change the greeting?', a: 'Yes. Type a different greeting, and the same card layout carries it.'},
        ],
    },
}
